/*
 * Public API Surface of ngx-hun-party-colors
 */

export * from './lib/hun-party-colors.module';

export * from './lib/hun-party-colors.service';
